module.exports = __webpack_public_path__ + "static/media/outrasInfos.7dcb1583.png";